import _ from 'lodash';

export default function buildRoute(routeTemplate, params, excludes) {
	const paramObject = _.omitBy(params, value => {
		if (Array.isArray(value)) {
			return value.length === 0;
		}
		return [undefined, null, ''].includes(value);
	});

	let parameters = '';

	if (paramObject) {
		let keys = Object.keys(paramObject);

		if (excludes) {
			keys = keys.filter(key => excludes.indexOf(key) === -1);
		}

		parameters =
			'?' +
			keys
				.map(k => {
					if (Array.isArray(paramObject[k])) {
						return paramObject[k]
							.map(function(item) {
								if (item) {
									return `${k}=${item}`;
								}
								return;
							})
							.join('&');
					}
					return `${k}=${encodeURIComponent(paramObject[k])}`;
				})
				.join('&');
	}

	return `${routeTemplate}${parameters}`;
}
